(function () {
  'use strict';

  var TXT = {
    open: 'Find my size',
    title: 'Find Your Size',
    sub: 'Enter your height and weight and we’ll recommend the right size',
    height: 'Height', weight: 'Weight', cm: 'cm', kg: 'kg',
    prefLabel: 'How do you like it to fit?',
    snug: 'Snug', normal: 'True to size', relaxed: 'Relaxed',
    go: 'FIND MY SIZE',
    rec: 'We recommend', badge: 'RECOMMENDED',
    sure: 'This is a confident fit for your measurements.',
    looser: 'if you prefer a looser fit',
    tighter: 'if you prefer a slimmer fit',
    outside: 'Your measurements are slightly outside our chart — this is the closest size. Feel free to contact us to double-check.',
    invalid: 'Enter a valid height (140–210 cm) and weight (40–150 kg).',
    pick: 'Select this size', picked: 'Size selected ✓',
    close: 'Close'
  };

  // Height range [min, max] in cm, weight range [min, max] in kg
  var CHARTS = {
    saudi: {
      name: 'Saudi Thobe',
      rows: [
        { size: '56 A', h: [155, 171], w: [55, 70]  },
        { size: '56 B', h: [155, 173], w: [60, 75]  },
        { size: '58 B', h: [169, 175], w: [70, 88]  },
        { size: '58 C', h: [169, 177], w: [75, 95]  },
        { size: '60 A', h: [174, 180], w: [70, 87]  },
        { size: '60 B', h: [174, 180], w: [75, 93]  },
        { size: '60 C', h: [174, 182], w: [80, 105] },
        { size: '62 B', h: [180, 187], w: [80, 97]  },
        { size: '62 C', h: [180, 189], w: [85, 105] },
        { size: '62 D', h: [190, 192], w: [90, 115] }
      ]
    },
    atlas: {
      name: 'Moroccan Thobe – Atlas',
      rows: [
        { size: '56', h: [155, 170], w: [55, 75]  },
        { size: '58', h: [171, 179], w: [70, 90]  },
        { size: '60', h: [180, 185], w: [80, 95]  },
        { size: '62', h: [186, 200], w: [85, 120] }
      ]
    },
    mezyan: {
      name: 'Moroccan Thobe – Mezyan',
      rows: [
        { size: '56 A', h: [155, 170], w: [60, 70]  },
        { size: '58 A', h: [169, 177], w: [65, 80]  },
        { size: '58 B', h: [169, 177], w: [81, 95]  },
        { size: '60 A', h: [174, 182], w: [70, 90]  },
        { size: '60 B', h: [174, 182], w: [91, 105] },
        { size: '62 A', h: [180, 200], w: [80, 94]  },
        { size: '62 B', h: [180, 200], w: [95, 120] }
      ]
    },
    sarwal: {
      name: 'Sarwal',
      rows: [
        { size: 'Medium', h: [150, 180], w: [50, 100]  },
        { size: 'Large',  h: [181, 220], w: [101, 200] }
      ]
    }
  };

  var LIMITS = { h: [140, 220], w: [40, 200] };
  var PREF_BIAS = { snug: -5, normal: 0, relaxed: 5 }; // kg shift
  var STORE_KEY = 'rawiFit';

  function norm(s) { return String(s || '').toUpperCase().replace(/\s+/g, ''); }

  // 0 = dead centre of the range, 1 = at the edge, >2 = outside
  function axis(x, range) {
    var lo = range[0], hi = range[1];
    var half = (hi - lo) / 2 || 1, c = (lo + hi) / 2;
    if (x < lo) return 2 + (lo - x) / half;
    if (x > hi) return 2 + (x - hi) / half;
    return Math.abs(x - c) / half;
  }

  function recommend(chart, h, w, pref) {
    var wEff = w + (PREF_BIAS[pref] || 0);
    var scored = chart.rows.map(function (r) {
      return {
        row: r,
        score: 1.15 * axis(h, r.h) + axis(wEff, r.w),
        inRange: axis(h, r.h) < 2 && axis(w, r.w) < 2
      };
    }).sort(function (a, b) { return a.score - b.score; });

    var best = scored[0], second = scored[1];
    var alt = (second && second.score - best.score <= 0.35) ? second : null;
    return {
      size: best.row.size,
      confident: best.inRange && best.score < 0.9,
      outside: !best.inRange,
      alt: alt ? alt.row.size : null,
      altLooser: alt ? (alt.row.w[0] + alt.row.w[1]) > (best.row.w[0] + best.row.w[1]) : false
    };
  }

  // Chart is now decided ONLY by the explicit data-chart attribute (set in
  // Liquid from the product's metafield/tag) — no more guessing from the
  // shape of the size values. With saudi (56 A), atlas (56), mezyan (56 A)
  // and sarwal (Medium) all using different but overlapping formats,
  // auto-detection can no longer tell them apart reliably.
  function detectChart(host) {
    var explicit = host.getAttribute('data-chart');
    if (explicit && CHARTS[explicit]) return explicit;
    return null;
  }

  /* ---------- modal ---------- */
  var modal, state = { host: null, chartKey: null, sizes: [], pref: 'normal' };

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'rawi-fit-modal';
    modal.setAttribute('dir', 'ltr');
    modal.innerHTML =
      '<div class="rawi-fit-modal__overlay" data-rawi-close></div>' +
      '<div class="rawi-fit-modal__box" role="dialog" aria-modal="true">' +
        '<button class="rawi-fit-modal__x" data-rawi-close aria-label="' + TXT.close + '">&times;</button>' +
        '<h2 class="rawi-fit__title">' + TXT.title + '</h2>' +
        '<p class="rawi-fit__chartname" data-rawi-chartname></p>' +
        '<p class="rawi-fit__sub">' + TXT.sub + '</p>' +
        '<div class="rawi-fit__fields">' +
          '<label class="rawi-fit__field"><span>' + TXT.height + '</span>' +
            '<span class="rawi-fit__input"><input type="number" inputmode="numeric" min="140" max="220" data-rawi-h placeholder="175"><em>' + TXT.cm + '</em></span></label>' +
          '<label class="rawi-fit__field"><span>' + TXT.weight + '</span>' +
            '<span class="rawi-fit__input"><input type="number" inputmode="numeric" min="40" max="200" data-rawi-w placeholder="75"><em>' + TXT.kg + '</em></span></label>' +
        '</div>' +
        '<div class="rawi-fit__pref"><span class="rawi-fit__pref-lbl">' + TXT.prefLabel + '</span>' +
          '<div class="rawi-fit__pref-row">' +
            '<button type="button" data-pref="snug">' + TXT.snug + '</button>' +
            '<button type="button" data-pref="normal" class="is-on">' + TXT.normal + '</button>' +
            '<button type="button" data-pref="relaxed">' + TXT.relaxed + '</button>' +
          '</div></div>' +
        '<button type="button" class="rawi-fit__go" data-rawi-go>' + TXT.go + '</button>' +
        '<div class="rawi-fit__result" data-rawi-result hidden></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rawi-close]')) return close();
      var p = e.target.closest('[data-pref]');
      if (p) {
        state.pref = p.getAttribute('data-pref');
        modal.querySelectorAll('[data-pref]').forEach(function (b) { b.classList.toggle('is-on', b === p); });
        if (!modal.querySelector('[data-rawi-result]').hidden) run();
        return;
      }
      if (e.target.closest('[data-rawi-go]')) return run();
      var pick = e.target.closest('[data-rawi-pick]');
      if (pick) return applySize(pick.getAttribute('data-rawi-pick'), pick);
    });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Enter') run(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function open(host) {
    if (!modal) buildModal();
    state.host = host;
    try {
      var el = host.querySelector('[data-rawi-sizes]');
      state.sizes = el ? JSON.parse(el.textContent) : [];
    } catch (err) { state.sizes = []; }

    state.chartKey = detectChart(host);
    if (!state.chartKey) {
      console.warn('[rawi-fit] no size chart set for this product:', location.pathname);
      return;
    }

    modal.querySelector('[data-rawi-chartname]').textContent = CHARTS[state.chartKey].name;
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) {}
    if (saved.h) modal.querySelector('[data-rawi-h]').value = saved.h;
    if (saved.w) modal.querySelector('[data-rawi-w]').value = saved.w;
    state.pref = saved.pref || 'normal';
    modal.querySelectorAll('[data-pref]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-pref') === state.pref);
    });
    modal.querySelector('[data-rawi-result]').hidden = true;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function run() {
    var box = modal.querySelector('[data-rawi-result]');
    var h = parseFloat(modal.querySelector('[data-rawi-h]').value);
    var w = parseFloat(modal.querySelector('[data-rawi-w]').value);
    var bad = !h || !w || h < LIMITS.h[0] || h > LIMITS.h[1] || w < LIMITS.w[0] || w > LIMITS.w[1];
    box.hidden = false;
    if (bad) { box.className = 'rawi-fit__result is-error'; box.textContent = TXT.invalid; return; }

    try { localStorage.setItem(STORE_KEY, JSON.stringify({ h: h, w: w, pref: state.pref })); } catch (e) {}

    var r = recommend(CHARTS[state.chartKey], h, w, state.pref);
    var note = r.outside ? TXT.outside
      : r.alt ? '<b>' + r.alt + '</b> ' + (r.altLooser ? TXT.looser : TXT.tighter)
      : TXT.sure;

    box.className = 'rawi-fit__result';
    box.innerHTML =
      '<div class="rawi-fit__rec"><span>' + TXT.rec + '</span>' +
      '<strong>' + r.size + '</strong><i>' + TXT.badge + '</i></div>' +
      '<p class="rawi-fit__note">' + note + '</p>' +
      (matchOption(r.size) ? '<button type="button" class="rawi-fit__pick" data-rawi-pick="' + r.size + '">' + TXT.pick + '</button>' : '');
  }

  function matchOption(size) {
    for (var i = 0; i < state.sizes.length; i++) {
      var v = state.sizes[i]; v = (v && v.name) ? v.name : v;
      if (norm(v) === norm(size)) return v;
    }
    return null;
  }

  function applySize(size, btn) {
    var value = matchOption(size);
    if (!value) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var scope = (form && (form.closest('.product') || form.closest('product-info'))) || document;
    var done = false;

    scope.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (!done && norm(i.value) === norm(value)) { i.click(); done = true; }
    });
    if (!done) {
      scope.querySelectorAll('select').forEach(function (s) {
        if (done) return;
        for (var i = 0; i < s.options.length; i++) {
          if (norm(s.options[i].value) === norm(value)) {
            s.selectedIndex = i;
            s.dispatchEvent(new Event('change', { bubbles: true }));
            done = true; break;
          }
        }
      });
    }
    if (done) { btn.textContent = TXT.picked; btn.disabled = true; setTimeout(close, 700); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rawi-open]');
    if (!b) return;
    e.preventDefault();
    open(b.closest('[data-rawi-fit]'));
  });
})();